// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getContactos as listContactosAPI,
    getContacto as getContactoAPI,
    updateContacto as updateContactoAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { contactosApiResponseError, contactosApiResponseSuccess } from './actions';
import { ContactosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getContacto({ payload: { contactoId } }) {
    try {
        const response = yield call(getContactoAPI, contactoId );
        const contacto = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(contactosApiResponseSuccess(ContactosActionTypes.GET_CONTACTO, contacto));
    } catch (error) {
        yield put(contactosApiResponseError(ContactosActionTypes.GET_CONTACTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listContactos() {
    try {
        const response = yield call(listContactosAPI);
        const listaContactos = response.data.data.contactos;
        yield put(contactosApiResponseSuccess(ContactosActionTypes.LIST_CONTACTOS, listaContactos));
    } catch (error) {
        yield put(contactosApiResponseError(ContactosActionTypes.LIST_CONTACTOS, error));
    }
}

function* updateContacto({payload:contacto}){
    try{
        const response = yield call(updateContactoAPI,{...contacto})
        const contact = response.data.data
        yield put(contactosApiResponseSuccess(ContactosActionTypes.UPDATE_CONTACTO,contact))
    }catch(error){
        yield put(contactosApiResponseError(ContactosActionTypes.UPDATE_CONTACTO,error))
    }
}


export function* watchGetContacto(): any {
    yield takeEvery(ContactosActionTypes.GET_CONTACTO, getContacto);
}

export function* watchListContactos(): any {
    yield takeEvery(ContactosActionTypes.LIST_CONTACTOS, listContactos);
}

export function* watchUpdateContacto(): any{
    yield takeEvery(ContactosActionTypes.UPDATE_CONTACTO, updateContacto);
}


function* contactosSaga(): any {
    yield all([
        fork(watchGetContacto),
        fork(watchListContactos),
        fork(watchUpdateContacto),
    ]);
}

export default contactosSaga;
